export default function PHP_str_shuffle() {
  return (
    <div>
      <h1>PHP_str_shuffle</h1>
    </div>
  );
}
